// extracted by mini-css-extract-plugin
export var bgImage = "header-background-v3-module--bgImage--bbdf5";
export var containerHeader = "header-background-v3-module--containerHeader--95b79";
export var header = "header-background-v3-module--header--31791";
export var topic = "header-background-v3-module--topic--09414";